import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import Colors from '../../../../../ui/global/Colors';
import Button from '../../../../../ui/components/Button';
import StreamStateProvider from '../helpers/StreamStateProvider';
import GameStream from '../components/GameStream';
import { useStreamContext } from '../helpers/StreamContext';
import { useStreamUIState } from '../helpers/streamStore';
import { useConfig } from '../../../../../utils/config';
import { generateAICode } from '../../../../../ai/CodeAI';
import { streamLog } from '../helpers/streamLogger';

const Root = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    min-height: 100svh;
    background-color: ${Colors.black};
    color: ${Colors.white};
    padding: 20px;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 20px;
`;

const StreamContainer = styled.div`
    width: 100%;
    max-width: 800px;
    flex: 1;
`;

const Test = () => {
    const config = useConfig();
    const [isStreamActive, setIsStreamActive] = useState(false);
    const { streamContext } = useStreamContext();
    const { content } = useStreamUIState();
    const hasStreamContent = content.blocks.length > 0;

    const handleTestClick = async () => {
        try { streamLog.debug('Test button clicked!'); } catch (_) {}
        
        if (isStreamActive) {
            setIsStreamActive(false);
            streamContext?.clearContent();
        } else {
            try {
                await startRealStream();
            } catch (error) {
                try { streamLog.error('Failed to start stream:', error); } catch (_) {}
                streamContext?.setIsStreaming(false);
            }
        }
    };

    const startRealStream = async () => {
        if (!streamContext) {
            try { streamLog.error('Stream context not available'); } catch (_) {}
            return;
        }

        // Clear existing content; orchestrator will update streaming state and phase
        streamContext.clearContent();
        setIsStreamActive(true);

        try {
            await generateAICode({
                req: {
                    prompt: 'neobrutalist snake game',
                    historyEntryId: `test-${Date.now()}`,
                    streamContext,
                } as any,
                config,
                gameId: `test-game-${Date.now()}`,
                isInitialCreate: true,
                forceStreamEndpoint: true,
            });
        } catch (error) {
            try { streamLog.error('Failed to start stream:', error); } catch (_) {}
            streamContext.setIsStreaming(false);
            streamContext.setStreamPhase('Error');
            streamContext.addTextContent(`Failed to start stream: ${error instanceof Error ? error.message : 'Unknown error'}`);
        } finally {
            setIsStreamActive(false);
        }
    };

    const handleHasContentChange = useCallback(() => {
        try { streamLog.debug('Stream has content:', hasStreamContent); } catch (_) {}
    }, [hasStreamContent]);

    return (
        <Root>
            <ButtonContainer>
                <Button 
                    text={isStreamActive ? "Stop Stream" : "Start Stream"} 
                    onClick={handleTestClick}
                    color="white"
                    size="medium"
                    disabled={!streamContext}
                />
            </ButtonContainer>
            <StreamContainer>
                <StreamStateProvider config={config} isActive={true} onStreamContext={() => {}} />
                <GameStream isExpanded={true} />
            </StreamContainer>
        </Root>
    );
};

export default Test;
